// extracted by mini-css-extract-plugin
export default {"mobileBreakPoint":"780px","paragraph":"paragraph_paragraph__mPKox"};